import DocsConfig from '@tencent/docs-config';
const appConfigInstance = DocsConfig.getInstance();
const npmConfig = appConfigInstance.getConfig('npm["@tencent/docs-design-resources"]')
let p = (!!npmConfig && npmConfig.CDN_ORIGIN) || 'https://docs.gtimg.com/docs-design-resources';
p = p + '/cooperation/ai/template/template_ppt_simple_minimalist_dark/'
export function getTemplateThumbnail1() { return p+'template_thumbnail_1-0df8d7be6d.png'; };
export function getTemplateThumbnail10() { return p+'template_thumbnail_10-8f257f4577.png'; };
export function getTemplateThumbnail2() { return p+'template_thumbnail_2-c221ee7794.png'; };
export function getTemplateThumbnail3() { return p+'template_thumbnail_3-bb7fe663be.png'; };
export function getTemplateThumbnail4() { return p+'template_thumbnail_4-709ef4a25c.png'; };
export function getTemplateThumbnail5() { return p+'template_thumbnail_5-1ea8dfcbdd.png'; };
export function getTemplateThumbnail6() { return p+'template_thumbnail_6-fd1c352c39.png'; };
export function getTemplateThumbnail7() { return p+'template_thumbnail_7-734048c87e.png'; };
export function getTemplateThumbnail8() { return p+'template_thumbnail_8-727ee90510.png'; };
export function getTemplateThumbnail9() { return p+'template_thumbnail_9-40a0532858.png'; };
